// extracted by mini-css-extract-plugin
export default {"resetAppListWrapper":"resetAppElement_resetAppListWrapper__uthOp","resetFormWrapper":"resetAppElement_resetFormWrapper__XB8t+"};